import React from 'react';
import { FadeIn } from './FadeIn';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './Accordion';
export function FaqSection() {
  return <section className="py-12 md:py-16 bg-stone-950 px-4 sm:px-6 lg:px-8" data-id="element-140">
      <div className="max-w-3xl mx-auto" data-id="element-141">
        <FadeIn className="text-center mb-16" data-id="element-142">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-143">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-144">
          <Accordion type="single" collapsible className="w-full space-y-4" data-id="element-145">
            <AccordionItem value="item-1" className="border-stone-800 bg-stone-900 rounded-lg px-6" data-id="element-146">
              <AccordionTrigger className="text-left text-lg font-medium text-white hover:text-amber-400 py-6" data-id="element-147">
                ¿Funciona si lo hago en el móvil?
              </AccordionTrigger>
              <AccordionContent className="text-stone-400 text-base pb-6 leading-relaxed" data-id="element-148">
                No, la luz azul y las notificaciones son contraproducentes; el
                contacto físico del lápiz es clave para la descarga motora.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2" className="border-stone-800 bg-stone-900 rounded-lg px-6" data-id="element-149">
              <AccordionTrigger className="text-left text-lg font-medium text-white hover:text-amber-400 py-6" data-id="element-150">
                ¿Tengo que saber escribir bien?
              </AccordionTrigger>
              <AccordionContent className="text-stone-400 text-base pb-6 leading-relaxed" data-id="element-151">
                En absoluto, puedes usar palabras sueltas o garabatos; es un
                proceso privado de limpieza mental.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3" className="border-stone-800 bg-stone-900 rounded-lg px-6" data-id="element-152">
              <AccordionTrigger className="text-left text-lg font-medium text-white hover:text-amber-400 py-6" data-id="element-153">
                ¿Cuánto tiempo toma realmente?
              </AccordionTrigger>
              <AccordionContent className="text-stone-400 text-base pb-6 leading-relaxed" data-id="element-154">
                Una vez dominas el protocolo P.A.U., toma entre 3 y 5 minutos
                exactos.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </FadeIn>
      </div>
    </section>;
}